function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
  fill: "#643DA7"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.7127 36.4415C21.6954 36.4415 20.6793 36.4415 19.6626 36.4415C19.6626 35.4281 19.6626 34.4158 19.6626 33.3847C17.868 33.3847 16.108 33.3847 14.3246 33.3847C14.3246 33.2991 14.3246 33.2297 14.3246 33.1602C14.3246 27.9895 14.324 22.8193 14.3273 17.6485C14.3279 17.5335 14.354 17.4118 14.3951 17.3046C14.8479 16.1284 15.3107 14.955 15.7607 13.7767C15.8246 13.6072 15.9107 13.5594 16.0891 13.5594C22.5304 13.565 28.9718 13.5639 35.4121 13.5639C35.4954 13.5639 35.5799 13.5639 35.6765 13.5639C35.6765 13.6528 35.6765 13.7072 35.6765 13.7622C35.6765 18.2102 35.6776 22.6581 35.6699 27.105C35.6699 27.2155 35.6076 27.3511 35.5287 27.4294C33.5964 29.3717 31.6591 31.3096 29.7157 33.2413C29.6335 33.3247 29.4857 33.3836 29.3679 33.3847C27.994 33.3947 26.6206 33.3947 25.2467 33.3869C25.0694 33.3858 24.96 33.4358 24.8528 33.5814C24.1455 34.5381 23.4271 35.4887 22.7127 36.4415ZM33.3887 15.8684C28.0351 15.8684 22.7116 15.8684 17.3936 15.8684C17.3936 20.7003 17.3936 25.516 17.3936 30.349C18.9175 30.349 20.4237 30.349 21.9543 30.349C21.9543 31.3518 21.9543 32.3391 21.9543 33.373C22.0521 33.2808 22.1154 33.2241 22.1749 33.1647C23.0677 32.273 23.9577 31.3763 24.8578 30.4912C24.9417 30.409 25.0872 30.3479 25.2044 30.3468C26.5856 30.3368 27.9684 30.3368 29.3502 30.3434C29.5157 30.3446 29.628 30.2923 29.743 30.1762C30.9013 29.0106 32.0642 27.8478 33.2303 26.69C33.347 26.5738 33.3914 26.4588 33.3914 26.2949C33.387 22.9031 33.3881 19.5119 33.3881 16.1218C33.3887 16.0434 33.3887 15.964 33.3887 15.8684Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.7249 19.6752C23.4805 19.6752 24.2238 19.6752 24.9833 19.6752C24.9833 21.6981 24.9833 23.7171 24.9833 25.751C24.2344 25.751 23.4855 25.751 22.7249 25.751C22.7249 23.7304 22.7249 21.7164 22.7249 19.6752Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.5585 25.7549C28.799 25.7549 28.0562 25.7549 27.3006 25.7549C27.3006 23.7298 27.3006 21.717 27.3006 19.6836C28.044 19.6836 28.7929 19.6836 29.5585 19.6836C29.5585 21.697 29.5585 23.716 29.5585 25.7549Z",
  fill: "white"
});

var SvgSourceTwitch = function SvgSourceTwitch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceTwitch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_twitch.97cfd77a.svg";
export { ForwardRef as ReactComponent };